module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp"
  }, [_c('div', {
    staticClass: "pp-icon"
  }, [_c('i', {
    class: 'fa fa-' + _vm.icon
  })]), _vm._v(" "), _c('strong', [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._t("description")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119398da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/technology/components/pro-point.vue
// module id = 303
// module chunks = 1